"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.clear = exports.deleteLatestRevisionFailed = exports.deleteLatestRevisionSuccess = exports.deleteLatestRevisionRequest = exports.toggleSelect = exports.setOrder = exports.setColumnFilterString = exports.fetchFailed = exports.fetchSuccess = exports.fetchRequest = void 0;
const _revisionsActions = require("../../modules/revisions/actions");
const revisionsActions = _revisionsActions.default('files');
exports.fetchRequest = revisionsActions.fetchRequest;
exports.fetchSuccess = revisionsActions.fetchSuccess;
exports.fetchFailed = revisionsActions.fetchFailed;
exports.setColumnFilterString = revisionsActions.setColumnFilterString;
exports.setOrder = revisionsActions.setOrder;
exports.toggleSelect = revisionsActions.toggleSelect;
exports.deleteLatestRevisionRequest = revisionsActions.deleteLatestRevisionRequest;
exports.deleteLatestRevisionSuccess = revisionsActions.deleteLatestRevisionSuccess;
exports.deleteLatestRevisionFailed = revisionsActions.deleteLatestRevisionFailed;
exports.clear = revisionsActions.clear;
//# sourceMappingURL=index.js.map